import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getPageName } from '../../utils/pageName';
import {
  withLoginModal,
  WithLoginModalProps,
} from '../../login/withLoginModal';
import {
  ModalConfirmationContainer,
  ModalConfirmationHeader,
  ModalConfirmationFooter,
  ModalConfirmationContent,
  ModalActions,
} from '../../components/modal';
import { BrandButton } from '../../components/button';
import styles from './professional_page_owner_modal.module.scss';
import { LawyerSummary } from '../summary/LawyerSummary';

type Props = {
  closeModal: () => void;
  source: string;
  name: string;
  lawyerHasRetired: boolean;
  isOpen: boolean;
} & WithLoginModalProps;

export const RawProfessionalPageOwnerModal: FC<Props> = ({
  name,
  isOpen,
  closeModal,
  lawyerHasRetired,
  source,
  openLoginModal,
}) => {
  const sourcePage: string = getPageName();

  const openLoginCta = () => {
    closeModal();
    openLoginModal(source);
  };

  return (
    <ModalConfirmationContainer isOpen={isOpen} onRequestClose={closeModal}>
      <ModalConfirmationHeader
        title={<FormattedMessage id="ProfessionalPageOwnerModal/takePage" />}
        onClose={closeModal}
      />
      <ModalConfirmationContent>
        <LawyerSummary lawyerHasRetired={lawyerHasRetired} lawyerName={name} />
        <br />
        <FormattedMessage id="ProfessionalPageOwnerModal/createAccount" />
      </ModalConfirmationContent>
      <ModalConfirmationFooter>
        <ModalActions>
          <div className={styles.discreet}>
            <FormattedMessage id="ProfessionalPageOwnerModal/already" />
            <button
              type="button"
              className={styles.link}
              onClick={openLoginCta}
            >
              <FormattedMessage id="ProfessionalPageOwnerModal/signIn" />
            </button>
          </div>
          <BrandButton
            onClick={() => {
              window.location.href = `/inscription?source=${source}&sourcePage=${sourcePage}`;
            }}
          >
            <FormattedMessage id="ProfessionalPageOwnerModal/signUp" />
          </BrandButton>
        </ModalActions>
      </ModalConfirmationFooter>
    </ModalConfirmationContainer>
  );
};

export const ProfessionalPageOwnerModal = withLoginModal(
  RawProfessionalPageOwnerModal,
);
